import axios from 'axios'
import { isDebug } from '../utils/env'
import { getAuthHeaders, signOut } from '@/utils/session'
export const fifthUrl = isDebug()
  ? 'https://5thave-dev.bieyangapp.com'
  : 'https://5thave-prod.bieyangapp.com'

const fifthaveClient = axios.create({
  baseURL: fifthUrl,
  // withCredentials: true,
  headers: {},
  timeout: 1000 * 60 * 10,
})

fifthaveClient.interceptors.request.use(
  (config: any) => {
    if (config.method === 'get') {
      // fix axios issue: https://github.com/axios/axios/issues/86
      config.data = {}
    }
    config.headers = {
      ...config.headers,
      ...getAuthHeaders(),
    }
    return config
  },
  (error: any) => {
    return error
  }
)

// 添加响应拦截器
fifthaveClient.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error?.response?.status === 401) {
      signOut()
    }
    return Promise.reject(error)
  }
)

export default fifthaveClient
